import { Box, Button, Grid2, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step1 = ({
  sra,
  setSra,
  setStep,
  storedUser,
  fileNames,
  setFileNames,
}) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.title)) {
      newErrors.title = "Title is required";
    }

    if (isEmpty(data.customerName)) {
      newErrors.customerName = "Customer Name is required";
    }

    if (isEmpty(data.poc)) {
      newErrors.poc = "Point of Contact is required";
    }

    if (isEmpty(data.email)) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      newErrors.email = "Enter a valid email";
    }

    if (isEmpty(data.phone)) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(data.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }

    if (isEmpty(data.address)) {
      newErrors.address = "Address is required";
    }

    if (isEmpty(data.cause)) {
      newErrors.cause = "Critical Cause is required";
    }

    if (isEmpty(data.information)) {
      newErrors.information = "Information is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/dashboard");
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>New Customer Approval Form</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "20%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Details</Typography>

        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="title">
              Title <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.title && "input-error"}`}
              type="text"
              name="title"
              id="title"
              onChange={handleChange}
              value={sra?.title || ""}
            />
            {errors.title && <p className="error">{errors.title}</p>}
          </Grid2>
          
          {/* Customer Name */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="customerName">
              Customer Name <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.customerName && "input-error"}`}
              type="text"
              name="customerName"
              id="customerName"
              onChange={handleChange}
              value={sra?.customerName || ""}
            />
            {errors.customerName && (
              <p className="error">{errors.customerName}</p>
            )}
          </Grid2>

          {/* POC */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="poc">
              Point of Contact <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.poc && "input-error"}`}
              type="text"
              name="poc"
              id="poc"
              onChange={handleChange}
              value={sra?.poc || ""}
            />
            {errors.poc && <p className="error">{errors.poc}</p>}
          </Grid2>

          {/* Email */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="email">
              Email <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.email && "input-error"}`}
              type="email"
              name="email"
              id="email"
              onChange={handleChange}
              value={sra?.email || ""}
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </Grid2>

          {/* Phone */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="phone">
              Phone <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.phone && "input-error"}`}
              type="text"
              name="phone"
              id="phone"
              onChange={handleChange}
              value={sra?.phone || ""}
            />
            {errors.phone && <p className="error">{errors.phone}</p>}
          </Grid2>

          {/* Website */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="website">
              Website
            </label>
            <input
              className={`${errors.website && "input-error"}`}
              type="text"
              name="website"
              id="website"
              onChange={handleChange}
              value={sra?.website || ""}
            />
            {errors.website && <p className="error">{errors.website}</p>}
          </Grid2>

          {/* Address */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="address">
              Address <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.address && "input-error"}`}
              type="text"
              name="address"
              id="address"
              onChange={handleChange}
              value={sra?.address || ""}
            />
            {errors.address && <p className="error">{errors.address}</p>}
          </Grid2>

          {/* Cause */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="cause">
              Critical Clause <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.cause && "input-error"}`}
              type="text"
              name="cause"
              id="cause"
              onChange={handleChange}
              value={sra?.cause || ""}
            />
            {errors.cause && <p className="error">{errors.cause}</p>}
          </Grid2>

          {/* Information */}
          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="information">
              Customer Information <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.information && "input-error"}`}
              type="text"
              name="information"
              id="information"
              onChange={handleChange}
              value={sra?.information || ""}
              rows={2}
            />
            {errors.information && (
              <p className="error">{errors.information}</p>
            )}
          </Grid2>
        </Grid2>
      </div>

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleUpdate}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step1;
